<template>
    <div class="magnifier_content">
        <div class="magnifier_box" >
            <img-zoom :src="imglists[imgIndex] + ''" width="420" height="420" :bigsrc="imglists[imgIndex] + ''" :configs="configs"></img-zoom>
            <div class="magnifier_imglist_content">
                <div class="magnifier_imglist_left" @click="leftClick"><i class="icon iconfont icon-jinru"></i></div>
                <div class="magnifier_imglist">
                    <ul ref="imglist">
                        <li :class="{active: imgIndex == index}" v-for="(item, index) in imglists" :key="index" @click="imgclick(index)"><img :src="item" /></li>
                    </ul>
                </div>
                <div class="magnifier_imglist_right" @click="rightClick"><i class="icon iconfont icon-icon_zhankai_xiangxia1"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import imgZoom from 'vue2.0-zoom'
import { setInterval, clearInterval } from 'timers';
    export default {
        props: ['imglist'],
        components: {imgZoom},
        data() {
            return {
                imgIndex: 0, // 当前图片
                imglists: [], // 图片列表
                configs: { // 放大镜属性
                    width: 420, // 大图宽
                    height: 420, // 大图高
                    maskWidth: 100, // 遮罩宽
                    maskHeight: 100, // 遮罩高
                    maskColor: '#FF8000', // 遮罩颜色
                    maskOpacity: 0.3, //遮罩透明度
                },
            }
        },
        methods: {
            imgclick (index) {
                this.imgIndex = index
            },
            leftClick () {
                let clear
                let oImglist = this.$refs.imglist
                this.imgIndex--
                if (this.imgIndex < 0) this.imgIndex = this.imglists.length - 1

                if (this.imglists.length > 5 && this.imgIndex > 3 && (this.imgIndex <= this.imglists.length - 1)) {
                    this.$refs.imglist.style.left = - (this.imgIndex - 4) * 70 + 'px'
                }
            },
            rightClick () {
                let clear
                let oImglist = this.$refs.imglist
                this.imgIndex++
                if (this.imgIndex >= this.imglists.length) this.imgIndex = 0
                if (this.imgIndex <= this.imglists.length) this.$refs.imglist.style.left = 0

                if (this.imglists.length > 5 && this.imgIndex > 3 && (this.imgIndex <= this.imglists.length - 1)) {
                    this.$refs.imglist.style.left = - (this.imgIndex - 4) * 70 + 'px'
                }
            }
        },
        watch: {
            imglist () {
                this.imglists = this.imglist
            }
        }
    }
</script>

<style scoped>

.magnifier_imglist_content {
    width: 420px;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    overflow: hidden;
}

.magnifier_imglist_left,
.magnifier_imglist_right {
    width: 30px;
    height: 60px;
    line-height: 60px;
    flex-grow: 0;
    flex-shrink: 0;
    text-align: center;
    border: 1px solid #ccc;
    cursor: pointer;
}

.magnifier_imglist {
    width: 10px;
    height: 60px;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0 10px;
    position: relative;
    overflow: hidden;
}

.magnifier_imglist > ul {
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.magnifier_imglist > ul > li {
    width: 60px;
    height: 60px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 10px;
    border: 1px solid #e6e6e6;
    position: relative;
    cursor: pointer;
}

.magnifier_imglist > ul > li > img {
    width: 100%;
    height: 100%;
}

.magnifier_imglist > ul > li::after {
    content: '';
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, .5);
    opacity: .8;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.magnifier_imglist > ul > li.active,
.magnifier_imglist > ul > li:hover {
    border-color: #ff8000;
}

.magnifier_imglist > ul > li.active::after,
.magnifier_imglist > ul > li:hover::after {
    opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/component/imgMagnifier.vue